import { render, staticRenderFns } from "./JbManCorretivaDefeitos.vue?vue&type=template&id=fa98d064&"
import script from "./JbManCorretivaDefeitos.vue?vue&type=script&lang=js&"
export * from "./JbManCorretivaDefeitos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./JbManCorretivaDefeitos.vue?vue&type=style&index=1&id=fa98d064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports